<template>
  <el-dialog
      title="楼栋设置"
      :visible.sync="unitDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <div>
      <div class="flex align-center justify-between margin-bottom-sm" v-for="(item,index) in menJson" :key="index">
        <el-input placeholder="请输入单元名称" class="basis-xsm margin-right-sm"
                  v-model="menJson[index].danyuanname"></el-input>
        <div class="flex align-center justify-between basis-xsm margin-right-sm">
          <el-input placeholder="请输入" class="flex-sub" type="number"
                    v-model.number="menJson[index].danyuanchuan"></el-input>
          <span class="margin-left-xs">串</span>
        </div>
        <div class="flex align-center justify-between basis-sm margin-right-sm">
          <span>最高楼层数：</span>
          <el-input placeholder="请输入" class="flex-sub" type="number"
                    v-model.number="menJson[index].danyuangaodu"></el-input>
        </div>
        <i class="el-icon-delete font-size-xs" @click="deleteItem(index)"></i>
      </div>
      <el-button class="add-item" type="primary" @click="addItemem">新增单元</el-button>
      <div class="flex align-center justify-around padding-sm ">
        <el-button class="msg-btn" @click="reset">取消</el-button>
        <el-button class="msg-btn" type="primary" @click="submitData">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {menHuAdd} from "@/api/community";

export default {
  name: "unitDialog",
  data() {
    return {
      menJson: [
        {danyuanname: '', danyuanchuan: '', danyuangaodu: '',}
      ]
    }
  },
  props: {
    unitDialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    //  提交
    submitData() {
      if (this.menJson.length === 0) return this.$message.error('至少设置一个单元')
      let _errorList = []
      this.menJson.map((item, index) => {
        if (!item.danyuanname || !item.danyuanchuan || !item.danyuangaodu) {
          _errorList.push(index + 1)
        }
      })
      if (_errorList.length > 0) return this.$message.error(`第${_errorList.join(',')}行内容未填写完整`)
      this.$confirm('楼栋数据只能设置一次，设置成功后不可修改单元数量/串数/层高', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.sureSet()
      })
    },
    async sureSet() {
      let _state = await menHuAdd(this.$route.params.fid, JSON.stringify(this.menJson))
      this.$message.success(_state.info)
      this.$emit('cancelDialog', false)
    },
    //  取消
    reset() {
      this.$emit('cancelDialog', false)
    },
    //  删除单元
    deleteItem(index) {
      this.menJson.splice(index, 1)
    },
    //  新增单元
    addItemem() {
      this.menJson.push({danyuanname: '', danyuanchuan: '', danyuangaodu: '',})
    }
  },
  watch: {}
}
</script>

<style scoped lang="scss">
.add-item {
  display: block;
  width: 100%;
  margin-top: 20px;
}
</style>
